
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "27",
    "viewBox": "0 0 26 27"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill": "#000",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M22.88 25.177H1.43c-.253 0-.481-.155-.591-.391-.104-.236-.072-.52.09-.722L19.585.979c.228-.284.644-.324.917-.081s.312.668.078.951L2.821 23.828H22.88c.358 0 .65.303.65.675 0 .37-.293.674-.65.674z",
                        "transform": "translate(-390 -931) translate(355 916) translate(35 15)"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M15.314 24.874h-.046c-.357-.027-.63-.345-.604-.716.02-.263.026-.533.026-.796 0-3.726-1.638-7.155-4.498-9.41-.286-.223-.345-.648-.123-.945.214-.297.623-.357.91-.128 1.52 1.202 2.788 2.774 3.646 4.536.903 1.856 1.365 3.854 1.365 5.947 0 .297-.007.594-.026.884-.026.351-.312.628-.65.628zm1.177-8.181c-.117 0-.235-.048-.325-.135-.176-.183-.176-.486 0-.668l2.684-2.788c.175-.183.468-.183.643 0 .176.182.176.486 0 .668l-2.684 2.788c-.085.087-.201.135-.319.135z",
                        "transform": "translate(-390 -931) translate(355 916) translate(35 15)"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M19.175 16.693c-.117 0-.234-.048-.325-.135l-2.678-2.788c-.176-.182-.176-.486 0-.668.175-.183.468-.183.643 0l2.685 2.787c.175.183.175.486 0 .669-.091.087-.208.135-.325.135zm1.885-3.53c-.897 0-1.625-.757-1.625-1.688 0-.931.728-1.688 1.625-1.688s1.625.756 1.625 1.688c0 .931-.728 1.688-1.625 1.688zm0-2.43c-.396 0-.715.33-.715.742s.319.742.715.742c.396 0 .715-.33.715-.742s-.319-.742-.715-.742z",
                        "transform": "translate(-390 -931) translate(355 916) translate(35 15)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  